// Import Core Components here
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Utils } from "arv-reactcomponents";
import { ADDRESS_REGEX } from "../../../constants/regex";

class TextAreaInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textAreaInput: props.textAreaInput,
      AddressInputErrorMsg: "",
      AddressErrorClass: "",
      isValid: "is-invalid is-untouched",
    };
    this.onBlur = this.onBlur.bind(this);
    this.validateAddress = this.validateAddress.bind(this);
  }

  componentDidMount() {
    const { textAreaInput } = this.state;
    if (textAreaInput) {
      const e = {
        target: {
          value: textAreaInput,
        },
      };
      this.validateAddress(e);
    }
  }

  onBlur() {
    let AddressErrorClass = "nwc-hidden";
    let isValid = "";
    let AddressInputErrorMsg = "";
    const regexValue = ADDRESS_REGEX[1].pattern.test(this.state.textAreaInput);
    if (!regexValue) {
      AddressErrorClass = "";
      isValid = "is-invalid";
      AddressInputErrorMsg = ADDRESS_REGEX[1].msg;
    } else {
      AddressErrorClass = "nwc-hidden";
      isValid = "";
      AddressInputErrorMsg = "";
    }
    this.setState({ AddressErrorClass, isValid, AddressInputErrorMsg });
  }

  validateAddress(e) {
    this.setState({ AddressErrorClass: "nwc-hidden" });
    const validateAddressField = e.target.value;
    this.setState({
      textAreaInput: validateAddressField,
      isValid: "",
    });
    if (this.state.AddressInputErrorMsg) {
      this.setState({
        AddressErrorClass: "",
      });
    }
    this.props.onChange(validateAddressField);
  }

  render() {
    const {
      textAreaInput,
      AddressInputErrorMsg,
      AddressErrorClass,
      isValid,
    } = this.state;
    const { className, placeholder, name, ...otherProps } = this.props;
    return (
      <Fragment>
        <textarea
          className={`${className} ${isValid}`}
          name={name}
          onBlur={this.onBlur}
          onChange={this.validateAddress}
          placeholder={placeholder}
          type="text"
          value={textAreaInput}
        />
        <div className={`nw-form-err-msg ${AddressErrorClass}`}>
          {AddressInputErrorMsg}
        </div>
      </Fragment>
    );
  }
}

TextAreaInput.defaultProps = {
  className: "",
  textAreaInput: "",
  onValid: Utils.noop,
  onChange: Utils.noop,
};

TextAreaInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  textAreaInput: PropTypes.string,
  onValid: PropTypes.func,
  onChange: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: TextAreaInput,
  component: TextAreaInput,
};

export default ProjectComponent;
